<aside
  class="h-screen flex flex-col bg-base-100 text-base-content border-r border-base-200 transition-all duration-300 ease-in-out overflow-x-hidden"
  [class.w-64]="!collapsed"
  [class.w-20]="collapsed"
>
  <!-- ================= BRAND ================= -->
  <div class="h-16 flex items-center gap-3 px-4 border-b border-base-200">
    <div
      class="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10"
    >
      <span class="text-lg brand-logo-text font-semibold text-primary tracking-tight">
        {{ appConfig.shortName }}
      </span>
    </div>

    @if (!collapsed) {
    <span class="text-xl font-semibold tracking-[0.3px]">
      {{ appConfig.name }}
    </span>
    }
  </div>

  <!-- ================= MENU ================= -->
  <nav class="flex-1 overflow-y-auto py-4">
    <ul class="px-2 space-y-1">
      @for (item of menuItems; track item.label) { @if (hasAccess(item.roles)) {
      <!-- Important: li relative for inline submenu -->
      <li class="relative">
        <!-- MAIN ITEM -->
        <button
          type="button"
          class="group relative flex items-center w-full gap-3 px-3 py-2.5 rounded-xl transition-all hover:bg-base-200"
          [class.bg-base-200]="expandedMenu === item.label"
          [attr.data-tip]="collapsed ? item.label : null"
          [attr.data.label]="item.label"
          (click)="
            item.children
              ? toggleMenu(item.label, $event)
              : navigate(item.route)
          "
        >
          <!-- Active Indicator -->
          <span
            class="absolute left-0 top-2 bottom-2 w-1 rounded-r-full bg-primary transition-opacity"
            [class.opacity-100]="expandedMenu === item.label"
            [class.opacity-0]="expandedMenu !== item.label"
          ></span>

          <!-- Icon -->
          <div
            class="w-9 h-9 flex items-center justify-center rounded-lg bg-base-200 group-hover:bg-base-300 transition"
          >
            <i [class]="item.icon"></i>
          </div>

          <!-- Label -->
          @if (!collapsed) {
          <span class="flex-1 text-sm font-medium">
            {{ item.label }}
          </span>

          @if (item.children) {
          <i
            class="fa-solid fa-chevron-down text-xs transition-transform"
            [class.rotate-180]="expandedMenu === item.label"
          ></i>
          } }
        </button>

        <!-- SUBMENU -->

        @if (item.children && expandedMenu === item.label) {
        <!-- EXPANDED MODE -->
        @if (!collapsed) {
        <ul class="mt-1 ml-6 space-y-1 border-l border-base-200 pl-3">
          @for (child of item.children; track child.route) {
          <li>
            <a
              [routerLink]="child.route"
              routerLinkActive="bg-base-200 text-primary"
              class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm hover:bg-base-200 transition"
            >
              <div
                class="w-8 h-8 flex items-center justify-center rounded-lg bg-base-200"
              >
                <i [class]="child.icon"></i>
              </div>
              <span>{{ child.label }}</span>
            </a>
          </li>
          }
        </ul>
        }

        <!-- COLLAPSED MODE (FLOATING) -->
        @if (collapsed) {
        <div
          class="fixed z-50 w-48 bg-base-100 shadow-xl rounded-xl p-2 border border-base-200 animate-in fade-in zoom-in-95 duration-150"
          [style.left.px]="sidebarWidth"
          [style.top.px]="submenuTopPosition"
          style="transform: translateY(-50%)"
        >
          <ul class="space-y-1">
            @for (child of item.children; track child.route) {
            <li>
              <a
                [routerLink]="child.route"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-sm hover:bg-base-200 transition"
              >
                <i [class]="child.icon"></i>
                <span>{{ child.label }}</span>
              </a>
            </li>
            }
          </ul>
        </div>
        } }
      </li>
      } }
    </ul>
  </nav>

  <!-- ================= FOOTER ================= -->
  <div class="px-2 py-3 border-t border-base-200 space-y-1">
    <a
      [routerLink]="settingsPath()"
      routerLinkActive="bg-base-200 text-primary"
      class="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-base-200"
      data-tip="Settings"
    >
      <div
        class="w-9 h-9 flex items-center justify-center rounded-lg bg-base-200"
      >
        <i class="fa-solid fa-gear"></i>
      </div>
      @if (!collapsed) { <span class="text-sm">Settings</span> }
    </a>

    <button
      type="button"
      (click)="logout()"
      class="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-error/10 text-error"
      data-tip="Logout"
    >
      <div
        class="w-9 h-9 flex items-center justify-center rounded-lg bg-base-200"
      >
        <i class="fa-solid fa-power-off"></i>
      </div>
      @if (!collapsed) { <span class="text-sm">Logout</span> }
    </button>
  </div>
</aside>
